import { useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { Menu, X } from "lucide-react";
import { LogoMark } from "./Logo";
import { NAV_LINKS } from "../../data/site";
import { scrollToId } from "../../lib/scroll";

export const Header = () => {
  const [open, setOpen] = useState(false);
  const location = useLocation();
  const navigate = useNavigate();

  const go = (href) => {
    setOpen(false);
    if (location.pathname !== "/") {
      navigate("/");
      setTimeout(() => scrollToId(href), 400);
    } else {
      scrollToId(href);
    }
  };

  return (
    <header data-testid="site-header" className="fixed top-4 inset-x-0 z-50 px-4">
      <div className="max-w-4xl mx-auto rounded-2xl bg-white/85 backdrop-blur-xl border border-slate-200/70 shadow-[0_12px_40px_rgb(15,23,42,0.10)] h-16 pl-2 pr-2 flex items-center gap-4">
        <div className="flex items-center gap-3 shrink-0">
          <Link to="/" aria-label="Bestconduite78 — accueil" data-testid="header-logo-link" className="block">
            <LogoMark size={46} />
          </Link>
          <span className="hidden sm:block w-px h-8 bg-slate-200" aria-hidden="true" />
        </div>

        <nav className="hidden md:flex flex-1 items-center justify-center gap-9" aria-label="Navigation principale">
          {NAV_LINKS.map((l) => (
            <button
              key={l.href}
              data-testid={`nav-link-${l.href.slice(1)}`}
              onClick={() => go(l.href)}
              className="text-[15px] font-semibold text-slate-700 hover:text-violet-700 transition-colors duration-200"
            >
              {l.label}
            </button>
          ))}
        </nav>

        <button
          data-testid="header-cta-button"
          onClick={() => go("#contact")}
          className="btn-shine hidden md:block shrink-0 rounded-xl bg-violet-700 text-white text-[15px] font-bold px-7 py-3 hover:bg-violet-800 hover:-translate-y-0.5 hover:shadow-lg hover:shadow-violet-700/25 transition-[transform,background-color,box-shadow] duration-200"
        >
          Nous contacter
        </button>

        <button
          data-testid="mobile-menu-toggle"
          className="md:hidden ml-auto mr-2 p-2 text-slate-800"
          onClick={() => setOpen(!open)}
          aria-label={open ? "Fermer le menu" : "Ouvrir le menu"}
        >
          {open ? <X size={24} /> : <Menu size={24} />}
        </button>
      </div>

      {open && (
        <div data-testid="mobile-menu" className="md:hidden max-w-4xl mx-auto mt-2 rounded-2xl bg-white/95 backdrop-blur-xl border border-slate-200/70 shadow-xl px-6 py-5 flex flex-col gap-4">
          {NAV_LINKS.map((l) => (
            <button
              key={l.href}
              data-testid={`mobile-nav-link-${l.href.slice(1)}`}
              onClick={() => go(l.href)}
              className="text-left text-base font-semibold text-slate-700 hover:text-violet-700"
            >
              {l.label}
            </button>
          ))}
          <button
            data-testid="mobile-cta-button"
            onClick={() => go("#contact")}
            className="rounded-xl bg-violet-700 text-white font-bold px-6 py-3 mt-1"
          >
            Nous contacter
          </button>
        </div>
      )}
    </header>
  );
};
